module.exports = __webpack_public_path__ + "img/member_code.fcc6e056.png";